import app_data from './get-app-data';
import {print_icon} from '@massimo-cassandro/m-utilities/js-utilities/print-icon';

// template std: <div class="rating-stars" data-r="{{ row.recensione.rating|default() }}"></div>

export function buildRatingStars(options) {

  const default_options = {
    wrapper: null,

    // alternativa al dataset, prevale su quest'ultimo
    // sono ammessi valori decimali (vengono arrotondati a `.5`)
    rating_value: null,

    // se presente, il markup viene restituito all'interno del tag indicato
    // con l'aggiunta della classe `rating-stars`
    add_wrapper: null, // null || tag

    // se add_wrapper !== null, indica l'eventuale classe aggiuntiva (oltre a `rating-stars`)
    // da inserire
    add_wrapper_extra_class: null,

    // restituisce il markup invece di modificare il cointenuto dell'elemento `wrapper`
    // se true, edit e callback sono ignorati
    return_markup: false,

    // se `edit` == true, le stelle sono cliccabili
    // in modo che si possa cambiare la classe `rated` con un click, alla fine viene invocata
    // la funzione `callback`, se presente
    edit: false,
    callback: null
  };

  options = {...default_options, ...options};

  const star_icon_id = 'star',
    half_star_icon_id = 'star-half';

  // path file icone: app_data.icons

  const rating_value = options.rating_value?? (+options.wrapper?.dataset.r?? 0),
    rating = Math.round(rating_value / .5) * .5;
  let stars = '';

  for(let i = 1; i<= 5; i++) {
    stars += print_icon({
      id          : rating === (i - .5) ? half_star_icon_id : star_icon_id,
      svg_class   : 'icona' + (i <= Math.round(rating)? ' rated' : ''),
      icon_file   : app_data.icons
    });
  }

  let markup = `<span>${stars}</span>`;

  if(options.add_wrapper !== null) {
    // il dataset è aggiunto per controllo, e non viene utilizzato
    markup = `<${options.add_wrapper}
      class="rating-stars${options.add_wrapper_extra_class? ` ${options.add_wrapper_extra_class}` : ''}"
      data-r="${rating}">
        ${markup}
      </${options.add_wrapper}>`;
  }

  if(options.return_markup) {

    return markup;

  } else {
    options.wrapper.classList.toggle('rating-edit', options.edit);
    options.wrapper.innerHTML = markup;


    if(options.edit) {
      const stars = options.wrapper.querySelectorAll('.icona');

      stars.forEach((star, idx) => {

        star.addEventListener('mouseover', () => {
          stars.forEach((item, i) => {
            item.classList.toggle('over-on', i <= idx);
            item.classList.toggle('over-off', i > idx);
          });
        }, false);

        options.wrapper.querySelector(':scope > span').addEventListener('mouseleave', () => {
          stars.forEach(item => {
            item.classList.remove('over-on', 'over-off');
          });
        }, false);

        try {
          star.addEventListener('click', () => {
            const rating = idx + 1;
            stars.forEach((item, i) => {
              item.classList.remove('over-on', 'over-off');
              item.classList.toggle('rated', i <= idx);
            });
            options.wrapper.dataset.r = rating;
            if(options.callback && typeof options.callback === 'function') {
              options.callback(rating);
            }
          }, false);

        } catch (e) {
          console.error(e); // eslint-disable-line
        }

      });
    }
  } // end if options.return_markup

}

// inserisce in tutti gli elementi `.rating-stars` le icone con le stelle corrispondenti
// al valore dell'attributo `data-r`
export function buildAllRatingStars() {

  document.querySelectorAll('.rating-stars').forEach(wrapper => {
    buildRatingStars({wrapper: wrapper});
  });

}
